<template>
    <el-dialog
        class="add-remark"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Add Remark"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="addForm"
                :model="addForm"
                :rules="rules"
                label-width="80px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Shop" prop="shop_id" size="small">
                            <el-select
                                v-model="addForm.shop_id"
                                size="small"
                                clearable
                                filterable
                                placeholder="Placeholder Shop"
                            >
                                <el-option
                                    v-for="item in shopList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Customer" prop="user_id" size="small">
                            <el-select
                                v-model="addForm.user_id"
                                placeholder="Please input user"
                                filterable
                                clearable
                                :filter-method="userSelect"
                                :remote="true"
                            >
                                <el-option
                                    v-for="item in userList"
                                    :key="item.id"
                                    :label="item.username"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Desc" prop="remark" size="small">
                            <el-input
                                type="textarea"
                                v-model="addForm.remark"
                                placeholder="Please input remark"
                                :autosize="{ minRows: 4, maxRows: 8 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="addVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            addForm: {
                shop_id: "",
                user_id: "",
                remark: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input name",
                    },
                ],
                value: [
                    {
                        required: true,
                        message: "Please input ioss",
                    },
                ],
                time: [
                    {
                        required: true,
                        message: "Please select time",
                    },
                ],
            },
            userList:[],
        };
    },
    methods: {
        closeDialog() {
            this.addForm = {
                shop_id: "",
                user_id: "",
                remark: "",
            };
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .shopOrderRemark(
                            {
                                ...this.addForm,
                            },
                            "post",
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "新增成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        userSelect(val){
            cmofferApi.userSelect({keyword: val}, "get").then((res) => {
                if (res) {
                    this.userList = res.data;
                }
            });
        }
    },
    props: {
        addVisible: Boolean,
        tableItem: Object,
        funcName: String,
        shopList: () => Array,
    },
    watch: {
        addVisible(val) {
            if (val) {
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.add-remark {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
